import datte_slider from "../../../../images/main-slider/datte_slider.webp"
import egg_slider from "../../../../images/main-slider/egg_slider.webp"
import produits from "../../../../images/main-slider/charcuterie.webp"
import boucherie from "../../../../images/portfolio/project1/boucherie.webp"
import boucherie2 from "../../../../images/portfolio/project1/meat.webp"
import restauration from "../../../../images/portfolio/project1/hamburger.webp"
import restauration2 from "../../../../images/portfolio/project1/restauration.webp"
import primeur from "../../../../images/portfolio/project1/datte.webp"
import primeur2 from "../../../../images/portfolio/project1/datte_500.webp"
import bio from "../../../../images/portfolio/project1/bio.webp"
import oeuf from "../../../../images/portfolio/project1/egg.jpg"

export const projectContent1 = [
    {
        image: boucherie,
        projectName: 'Boucherie, Charcuterie',
    },
    {
        image: primeur,
        projectName: 'Primeur',
    },
    {
        image: bio,
        projectName: 'Bio',
    },
    {
        image: oeuf,
        projectName: 'Oeufs',
    },
    {
        image: boucherie2,
        projectName: 'Boucherie, Charcuterie',
    },
    {
        image: primeur2,
        projectName: 'Primeur',
    }
]

export const homeSliderContent_fr = [
    {
        image: datte_slider,
        title: "Packaging Solutions",
        description: "Chez DEVPACK, nous offrons une variété d’emballage sécurisé pour vos dattes. Nos barquettes alimentaires sont fabriquées en polystyrène expansé à 100 %. "
    },
    {
        image: egg_slider,
        title: "Box Oeufs",
        description: "Nos BOX Oeufs fabriqués à DEVPACK offrent une protection maximale pour vos produits !"
    },
    {
        image: produits,
        title: "Nos Produits",
        description: "Les barquettes DP de DEVPACK sont des barquettes libre-service auto-absorbantes en polystyrène expansé (PSX)."
    }
]

export const homeSliderContent_en = [
    {
        image: datte_slider,
        title: "Packaging Solutions",
        description: "At DEVPACK, we offer a variety of secure packaging for your dates. Our food trays are made of 100% expanded polystyrene."
    },
    {
        image: egg_slider,
        title: "Egg Box",
        description: "Our Egg BOXES made in DEVPACK offer maximum protection for your products!"
    },
    {
        image: produits,
        title: "Our products",
        description: "DEVPACK's DP trays are self-service self-absorbing expanded polystyrene (PSX) trays."
    }
]

export const homeSliderContent_tn = [
    {
        image: datte_slider,
        title: "حلول التعبئة والتغليف",
        description: "في DEVPACK ، نقدم مجموعة متنوعة من العبوات الآمنة لتواريخك. صواني الطعام الخاصة بنا مصنوعة من البوليسترين الممدد بنسبة 100٪."
    },
    {
        image: egg_slider,
        title: "علبة البيض",
        description: "توفر علب البيض المصنوعة في DEVPACK أقصى حماية لمنتجاتك!"
    },
    {
        image: produits,
        title: "منتجاتنا",
        description: "صواني DP من DEVPACK عبارة عن صواني بوليسترين ممدد ذاتية الخدمة (PSX) ذاتية الخدمة."
    }
]
